import { InputHTMLAttributes, memo } from "react";
import styles from "./Input.module.scss";

export type TTypeInput = "text" | "tel" | "email" | "date" | "number";
interface IInputProps extends InputHTMLAttributes<HTMLInputElement> {
  label: string;
  type: TTypeInput;
  id: string;
  placeholder: string;
  value: string;
  setValue?: (value: string, id?: number) => void;
  errorText?: string | null;
  required?: boolean;
}

export const Input = memo((props: IInputProps) => {
  const {
    label,
    value,
    setValue,
    type,
    id,
    placeholder,
    errorText,
    required = false,
    ...otherProps
  } = props;

  return (
    <div className={styles.inputGroup}>
      <label htmlFor={id} className={styles.inputLabel}>
        {label}
        {required && <span className={styles.required}> *</span>}
      </label>
      <input
        type={type}
        id={id}
        name={id}
        placeholder={placeholder}
        value={value}
        required={required}
        onChange={(e) => setValue && setValue(e.target.value)}
        className={styles.inputField}
        {...otherProps}
      />
      {errorText && <span className={styles.errorText}>{errorText}</span>}
    </div>
  );
});
